export const SET_SLIDES = 'SET_SLIDES';

export const setSlides = (slides) => {
  return {
    type: SET_SLIDES,
    payload: slides,
  };
};
